module.exports = __webpack_public_path__ + "img/FloatingCrane.33fe9eb2.gif";